import React from "react";
import ct from "class-types.macro";

interface Props {
  productListingView?: string;
}

export default function ProductReplacement({ productListingView }: Props) {
  return (
    <p
      className={ct(
        "font-semibold",
        "text-xs",
        "leading-none",
        "my-2",
        "text-gray-800",
        productListingView === "list"
          ? ct("xs:mx-auto", "xs:text-center")
          : ct("mx-auto", "text-center"),
      )}
    >
      This item was discontinued by manufacturer.
    </p>
  );
}
